import moment from 'moment-timezone'

const removeCsvExt = (filename: string) => {
  const csvExtPos = filename.toLowerCase().indexOf('.csv')
  if (csvExtPos > -1) {
    filename = filename.substring(0, csvExtPos)
  }
  return filename
}

const filePathParser = (filePath: string) => {
  const parts = filePath.match(/([-\w]+)/g)
  const region = parts![0]
  const cognitoId = parts![1]
  const fileFullName = filePath.substring(filePath.indexOf(parts![2]))

  const fileNameParts = fileFullName.match(/(\d+)/g)
  console.log('fileNameParts', fileNameParts)
  const orgId = fileNameParts![0]
  console.log('orgId', orgId)
  const timestamp = fileNameParts![1]
  console.log('timestamp', timestamp)
  let originalFileName = fileFullName.substring(fileFullName.indexOf(timestamp) + timestamp.length + 1)
  console.log('originalFileName', originalFileName)
  originalFileName = removeCsvExt(originalFileName)

  const year = moment(timestamp, 'x').utc().year()
  return {
    region,
    cognitoId,
    fileFullName,
    orgId,
    timestamp,
    originalFileName,
    year,
  }
}

const fileNameParser = (filename: string) => {
  const originalFileName = removeCsvExt(filename)

  return {
    originalFileName,
  }
}

export { filePathParser, fileNameParser }
